import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/'
import Login from '../views/login'
import PassWordFind from '../views/forget'
import SettingPassword from '../views/setting'
import getPageTitle from '@/utils/get-page-title'
import { setToken, getToken, removeToken } from '@/utils/cookies'
const _import = (file, path, resolve) => {
	if (!path) path = 'components';
	return require([`../${path}/${file}.vue`], resolve)
};
Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/login',
			name: '登录',
			meta: {
				title: '登录'
			},
			component: Login
		},
		{
			path: '/passWord-find',
			name: '找回密码',
			meta: {
				title: '找回密码'
			},
			component: PassWordFind
		},
		{
			path: '/setting-password',
			name: '设置账号',
			meta: {
				title: '设置账号'
			},
			component: SettingPassword
		},
		{
			path: '/',
			name: '首页',
			component: Layout,
			children: [{
				path: '',
				name: '首页',
				component(resolve) {
					_import('index', 'views/home', resolve)
				},
			}]
		},
		{
			path: '/',
			name: 'Layout',
			component: Layout,
			children: [				
				{
					path: 'home',
					name: '首页',
					meta: {
						title: '首页'
					},
					component(resolve) {
						_import('index', 'views/home', resolve)
					},
				},
				{
					path: 'shopCart',
					name: '购物车',
					meta: {
						needLogin: true,
						title: '购物车'
					},
					component(resolve) {
						_import('index', 'views/shopCart', resolve)
					},
				},
				{
					path: 'menu',
					name: '菜单',
					meta: {
						title: '菜单'
					},
					component(resolve) {
						_import('index', 'views/menu', resolve)
					},
				},
				{
					path: 'brand',
					name: '品牌故事',
					meta: {
						title: '品牌故事'
					},
					component(resolve) {
						_import('index', 'views/brand', resolve)
					},
				},
				{
					path: 'series',
					name: '产品系列',
					meta: {
						title: '产品系列'
					},
					component(resolve) {
						_import('index', 'views/series', resolve)
					},
				},
				{
					path: 'seriesDetail',
					name: '产品系列详情',
					component(resolve) {
						_import('index', 'views/seriesDetail', resolve)
					},
				},
				{
					path: 'characteristics',
					name: '工艺特点',
					meta: {
						needLogin: false,
						title: '工艺特点'
					},
					component(resolve) {
						_import('index', 'views/characteristics', resolve)
					},
				},
				{
					path: 'service',
					name: '服务介绍',
					meta: {
						needLogin: false,
						title: '服务介绍'
					},
					component(resolve) {
						_import('index', 'views/service', resolve)
					},
				},
				{
					path: 'contact',
					name: '联系我们',
					meta: {
						needLogin: false,
						title: '联系我们'
					},
					component(resolve) {
						_import('index', 'views/contact', resolve)
					},
				}
			]
		},
		{
			path: '*',
			name: '404未找到相关页面',
			meta: {
				title: '404未找到相关页面'
			},
			component(resolve) {
				_import('index', 'views/noPage', resolve)
			},
		}
	]
});
router.beforeEach((to, from, next) => {
	const info = getToken('DCI_USER');
	document.title = getPageTitle(to.meta.title)
	if(to.meta.needLogin){
		//必须登录
		if(info && JSON.parse(info).token){
			next()
		}else{
			next({
				path:'/login'
			})
		}
	}else{
		//不需要登录
		next()
		
	}
});

export default router
